import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../../components/commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import PlaceholderDateInput from '../../commonComponents/util/PlaceholderDateInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import AutocompleteSelect from '../../commonComponents/util/AutocompleteSelect';
import ThirdPartyPayeeModal from './ThirdPartyPayeeModal';

import { concatenateAddressLabel, formatBankInfoDisplay, formatDateForInput, isEmptyObj } from '../../../lib/utils';
import { PayeeTypes, SourceTypes } from '../../../lib/constants';
import { ManualPaymentTypes } from '../../../lib/systemVariables';

export default class PaymentInfo extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            isManualPayment: !this.props.paymentInfo.manualPayment || !this.props.paymentInfo.manualPayment.manualPaymentType ? false : true,
            blankCheck: null,
            showModals: {
                thirdPartyPayeeModal: false
            }
        };
    }

    updateIsManualPayment = event => {
        const { name, checked } = event.target;
        this.setState({isManualPayment: checked});
        let paymentInfo = this.props.paymentInfo

        if (checked) {
            paymentInfo.manualPayment = {
                blankCheckId: null,
                manualPaymentType: ManualPaymentTypes.BlankCheck,
                manualPaymentNumber: null,
                manualPaymentDate: null,
                manualPaymentAmount: null
            };
            if (this.props.payeeIsIsraeli) {
                paymentInfo = {
                    ...paymentInfo,
                    fundId: this.props.defaultUSFund || '',
                    thirdParty: {
                        ...this.props.paymentInfo.thirdParty,
                        bankNumber: '',
                        branchNumber: '',
                        accountNumber: '',
                        accountHolder: ''
                    }
                };
                this.props.updateApplication('paymentInfo', paymentInfo);
                if (this.props.defaultUSFund) this.props.getBlankChecks(this.props.defaultUSFund);
            } else {
                paymentInfo = {
                    ...paymentInfo,
                    thirdParty: {
                        ...paymentInfo.thirdParty,
                        useRecipientAddress: false,
                        careOf: ''
                    }
                };
                this.props.updateApplication('paymentInfo', paymentInfo);
                this.props.onChange('showCareOf', false);
                if (this.props.paymentInfo.fundId) this.props.getBlankChecks(this.props.paymentInfo.fundId);
            }
        } else {
            paymentInfo.manualPayment = {
                blankCheckId: null,
                manualPaymentType: null,
                manualPaymentNumber: null,
                manualPaymentDate: null,
                manualPaymentAmount: null
            };
            if (this.props.payeeIsIsraeli) {
                paymentInfo.fundId = this.props.defaultIsraeliFund;
            }

            this.props.updateApplication('paymentInfo', paymentInfo);
            this.props.onChange('manualCheckLabel', '');
        }
    }

    updateManualPaymentInfo = (name, value) => {
        let manualPaymentInfo = this.props.paymentInfo.manualPayment;
        if (name === 'blankCheckId') {
            let blankCheck = this.props.blankChecks.data.find(c => c.blankCheckId === value);
            this.setState({blankCheck});
            blankCheck ?
            manualPaymentInfo = {
                ...manualPaymentInfo,
                blankCheckId: blankCheck.blankCheckId,
                manualPaymentNumber: blankCheck.checkNumber,
                manualPaymentDate: blankCheck.checkDate,
                manualPaymentAmount: blankCheck.checkAmount
            } :
            manualPaymentInfo = {
                [name]: value,
                manualPaymentType: ManualPaymentTypes.BlankCheck,
                manualPaymentNumber: null,
                manualPaymentDate: null,
                manualPaymentAmount: null
            }
        } 
        else {
            if (name === "manualPaymentType") {
                if(value !== ManualPaymentTypes.BlankCheck && manualPaymentInfo.blankCheckId) {
                    this.setState({blankCheck: null});
                    manualPaymentInfo = {
                        ...manualPaymentInfo,
                        blankCheckId: null,
                        manualPaymentNumber: null,
                        manualPaymentAmount: null
                    }
                    this.props.onChange('manualCheckLabel', '');
                }
                else if(value === ManualPaymentTypes.BlankCheck) {
                    manualPaymentInfo = {
                        ...manualPaymentInfo,
                        manualPaymentNumber: null,
                        manualPaymentDate: null,
                        manualPaymentAmount: null
                    }
                }
            }
            manualPaymentInfo[name] = value;
        }
        this.props.updatePaymentInfo('manualPayment', {
            ...manualPaymentInfo
        });
    }

    updatePayableTo = (name, value) => {
        const isIsraeli = value === PayeeTypes.TrustedPayee ? this.props.trustedPayee.isIsraeli
            : this.props.initialThirdParty.isIsraeli; //will be equivalent to recipient.isIsraeli

        const fundId = isIsraeli === this.props.payeeIsIsraeli //don't update fundId if isIsraeli was not changed
            ? this.props.paymentInfo.fundId
            : (isIsraeli ? this.props.defaultIsraeliFund : this.props.defaultUSFund);

        this.props.updateApplication('paymentInfo', {
            ...this.props.paymentInfo,
            [name]: value,
            fundId,
            thirdParty: this.props.initialThirdParty
        });
    }

    updateThirdParty = thirdParty => {
        const fundId = (this.state.isManualPayment || thirdParty.isIsraeli === this.props.payeeIsIsraeli) //don't update fundId if manual check or if isIsraeli was not changed
            ? this.props.paymentInfo.fundId
            : (thirdParty.isIsraeli ? this.props.defaultIsraeliFund : this.props.defaultUSFund);

        this.props.updateApplication('paymentInfo', {
            ...this.props.paymentInfo,
            fundId,
            thirdParty: {
                ...thirdParty,
                ...(!this.state.isManualPayment && thirdParty.isIsraeli)
                    ? { useRecipientAddress: false, careOf: '' } : {} //if !manualCheck and switched to israeli, clear out US specfic fields
            }
        });

        if (this.props.showCareOf && !this.state.isManualPayment && thirdParty.isIsraeli)
            this.props.onChange('showCareOf', false); //if !manualCheck and switched to israeli, clear out showCareOf if checked
    }

    updateThirdPartyInfo = (name, value) => {
        const info = { ...this.props.paymentInfo.thirdParty, [name]: value };
        if (name === "referenceId") {
            const reference = this.props.recipientReferences[this.props.recipientReferences.map(ref => ref.referenceId.toString()).indexOf(value.toString())] || {};

            info.isIsraeli = reference.isIsraeli;
            info.firstName = reference.firstName || null;
            info.lastName = reference.lastName || null;
            info.orgName = reference.orgName || null;
            info.address = reference.address || null;
            info.bankNumber = reference.bankRoutingNumber || null;
            info.branchNumber = reference.bankBranchNumber || null;
            info.accountNumber = reference.bankAccountNumber || null;
            info.accountHolder = reference.bankAccountHolder || null;
        }

        this.updateThirdParty(info);
    }

    updateThirdPartyPayeeType = (name, value) => {
        this.props.onChange(name, value);
        this.updateThirdParty(this.props.initialThirdParty);
    }

    toggleCareOf = (name, value) => {
        this.props.onChange(name, value);

        if (!value && this.props.paymentInfo.thirdParty.careOf)
            this.updateThirdPartyInfo('careOf', '');
    }

    render() {
        const { showModals, isManualPayment, blankCheck } = this.state;
        const { applicationId, funds, campaignApplication, payeeIsIsraeli, paymentInfo, initialThirdParty, thirdPartyPayeeType, trustedPayee,
            recipientReferences, recipientAddress, recipientTypes, blankChecks, manualCheckLabel, showCareOf, submitAttempted } = this.props;
        const thirdParty = paymentInfo.thirdParty;

        let thirdPartyPaymentDescription;
        let missingThirdPartyPayeeInfo;
        const payToThirdParty = paymentInfo.payTo === PayeeTypes.ThirdParty;
        if (payToThirdParty) {
            const thirdPartyPayee = {
                name: thirdParty.orgName || `${thirdParty.firstName} ${thirdParty.lastName}`.trim(),
                address: thirdParty.useRecipientAddress ? recipientAddress : concatenateAddressLabel(thirdParty.address),
                bankInfo: formatBankInfoDisplay(thirdParty.bankNumber, thirdParty.branchNumber, thirdParty.accountNumber, thirdParty.accountHolder)
            };

            if (thirdPartyPayee.name && (payeeIsIsraeli ? thirdPartyPayee.bankInfo : thirdPartyPayee.address)) {
                if (isManualPayment) {
                    thirdPartyPaymentDescription = `Manual check will be made out to ${thirdPartyPayee.name}.`;
                } else {
                    thirdPartyPaymentDescription = payeeIsIsraeli ? `Payment will be wired to ${thirdPartyPayee.name} at bank account ${thirdPartyPayee.bankInfo}.`
                        : `Payment will be sent to ${thirdPartyPayee.name}${thirdParty.careOf ? ` C/O ${thirdParty.careOf}` : ''} at ${thirdPartyPayee.address}.`;
                }
            }

            if (!paymentInfo.useRecipientAddress && !isManualPayment && (payeeIsIsraeli ? !thirdPartyPayee.bankInfo : !thirdPartyPayee.address)) {
                missingThirdPartyPayeeInfo = payeeIsIsraeli ? "Bank Account Info" : "Address";
            }
        }

        return (
            <div className="payment-info">
                <div className="payment-info-box">
                    <h5 className="section-header">Payment Info</h5>
                    {this.props.manageAccounting && (applicationId || !campaignApplication) && <div>
                        <div className="custom-check-container">
                            <input className="custom-check"
                                type="checkbox" id="manualCheck"
                                name="isManualPayment"
                                checked={isManualPayment || false}
                                onChange={this.updateIsManualPayment} />
                            <label htmlFor="manualCheck">Manual Payment</label>
                        </div>
                        {isManualPayment &&
                            <Select name="manualPaymentType" value={paymentInfo.manualPayment.manualPaymentType}
                                options={this.props.manualPaymentTypes} 
                                onChange={e => this.updateManualPaymentInfo(e.target.name, e.target.value)}/>}
                    </div>}
                    <div>
                        <RadioGroup
                            options={[
                                ...trustedPayee ? [{ key: PayeeTypes.TrustedPayee, value: "Trusted Payee" }] : [],
                                { key: PayeeTypes.Recipient, value: "Recipient" },
                                { key: PayeeTypes.ThirdParty, value: "Third Party" }
                            ]}
                            title={isManualPayment ? "Paid To" : "Payable To"}
                            name='payTo' value={paymentInfo.payTo}
                            onChange={this.updatePayableTo} />
                    </div>
                    {paymentInfo.payTo === PayeeTypes.ThirdParty &&
                        <div className="third-party-info">
                            <p>Third Party Info</p>
                            <RadioGroup
                                options={[
                                    {
                                        key: SourceTypes.Reference,
                                        value: 'Choose reference as payee',
                                        error: submitAttempted && thirdPartyPayeeType === SourceTypes.Reference && !thirdParty.referenceId,
                                        disabled: !recipientReferences.length
                                    },
                                    {
                                        key: SourceTypes.New,
                                        value: 'Enter new payee',
                                        error: submitAttempted && thirdPartyPayeeType === SourceTypes.New && !(thirdParty.orgName || thirdParty.lastName),
                                        tag: !(thirdParty.orgName || thirdParty.lastName) && <span
                                            className={`link-text ${thirdPartyPayeeType !== SourceTypes.New ? "disabled" : ""} ${(thirdPartyPayeeType === SourceTypes.New && submitAttempted) ? "error" : ""}`}
                                            onClick={thirdPartyPayeeType === SourceTypes.New ? () => this.toggleModal("thirdPartyPayeeModal") : null}>Add</span>
                                    }
                                ]}
                                name='thirdPartyPayeeType'
                                value={thirdPartyPayeeType}
                                onChange={this.updateThirdPartyPayeeType} />

                            {thirdPartyPayeeType === SourceTypes.Reference
                                ? <div>
                                    <ValidatedInput input={<Select tabIndex={650}
                                        options={recipientReferences.map(ref => ({ key: ref.referenceId, value: ref.displayName }))} />}
                                        name="referenceId" value={thirdParty.referenceId}
                                        onChange={this.updateThirdPartyInfo}
                                        required={true} showRequiredError={submitAttempted}
                                    />
                                </div>
                                : (thirdParty.orgName || thirdParty.lastName) && <div className="payee-info">
                                    <p><span className="small-text bold-text accent-text">Payee Info: </span>
                                        <span className="link-text" onClick={() => this.toggleModal("thirdPartyPayeeModal")}>Edit</span></p>
                                    <p className="small-text"><span className="accent-text">Name:</span> {thirdParty.orgName || `${thirdParty.firstName} ${thirdParty.lastName}`}</p>
                                    {thirdParty.isIsraeli
                                        ? (thirdParty.accountNumber && <p className="small-text"><span className="accent-text">Bank Info:</span> <span>{formatBankInfoDisplay(thirdParty.bankNumber, thirdParty.branchNumber, thirdParty.accountNumber, thirdParty.accountHolder)}</span></p>)
                                        : (thirdParty.address.street && <p className="small-text"><span className="accent-text">Address:</span> <span>{concatenateAddressLabel(thirdParty.address)}</span></p>)}
                                    {submitAttempted && missingThirdPartyPayeeInfo && <label className="error-label">{`Third party ${missingThirdPartyPayeeInfo} is required.`}</label>}
                                </div>}

                            {(!payeeIsIsraeli && !isManualPayment) &&
                                <div className="payee-info-check">
                                    {recipientAddress &&
                                        <div className="custom-check-container">
                                            <input className="custom-check"
                                                type="checkbox" id="use-recipient-address-checkbox"
                                                checked={thirdParty.useRecipientAddress}
                                                onChange={e => this.updateThirdPartyInfo('useRecipientAddress', e.target.checked)} />
                                            <label htmlFor="use-recipient-address-checkbox" className="secondary-text">Use Recipient's Address</label>
                                        </div>}
                                    {(thirdParty.useRecipientAddress || thirdParty.referenceId || thirdParty.address.street) && <div>
                                        <div className="custom-check-container">
                                            <input className="custom-check"
                                                type="checkbox" id="careof-checkbox"
                                                checked={showCareOf}
                                                onChange={e => this.toggleCareOf("showCareOf", e.target.checked)} />
                                            <label htmlFor="careof-checkbox" className="secondary-text">Add Care of</label>
                                        </div>
                                        {showCareOf && <input type="text" placeholder="Care Of" tabIndex={660}
                                            name="careOf" value={thirdParty.careOf} onChange={e => this.updateThirdPartyInfo('careOf', e.target.value)} />}
                                    </div>}
                                </div>}

                            {thirdPartyPaymentDescription && <p className="accent-text xs-text">{thirdPartyPaymentDescription}</p>}

                        </div>}
                    <div className="payment-info-row">
                        <ValidatedInput input={<Select options={funds} tabIndex={690} />}
                            label="Fund" name="fundId" value={paymentInfo.fundId}
                            onChange={this.props.updatePaymentInfo}
                            required={true} showRequiredError={submitAttempted} />
                        {isManualPayment &&
                            <div>
                            {paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.BlankCheck ?
                                <ValidatedInput input={
                                    <AutocompleteSelect
                                        label={manualCheckLabel}
                                        updateLabel={val => this.props.onChange('manualCheckLabel', val)}
                                        tabIndex={700} disabledPlaceholder={'No Checks Found'}
                                        multi={false} placeholder='Manual Check' disabled={!paymentInfo.fundId}
                                        update={this.updateManualPaymentInfo}
                                        options={blankChecks.data.length ? blankChecks.data.map(check => ({
                                            key: check.blankCheckId,
                                            value: check.checkNumber
                                        })) : []}
                                        propertyName='blankCheckId' loading={blankChecks.loading} />}
                                    value={paymentInfo.manualPayment.blankCheckId}
                                    required={true} showRequiredError={submitAttempted} />
                                :
                                <ValidatedInput
                                    input={<input placeholder={`${paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.ManualWire ? "Wire" : "Check"} Number`} type="text" tabIndex={700} />}
                                    name="manualPaymentNumber"
                                    value={paymentInfo.manualPayment.manualPaymentNumber || ''}
                                    onChange={this.updateManualPaymentInfo}
                                    required={true}
                                    showRequiredError={submitAttempted} />}

                                {((paymentInfo.manualPayment.blankCheckId && paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.BlankCheck)  
                                    || (paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.ManualCheck || paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.ManualWire)) &&
                                    <div>
                                    <ValidatedInput
                                        input={<PlaceholderDateInput disabled={blankCheck && blankCheck.checkDate} placeholder={`${paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.ManualWire ? "Wire" : "Check"} Date`} tabIndex={710} />}
                                        name="manualPaymentDate"
                                        value={formatDateForInput(paymentInfo.manualPayment.manualPaymentDate)}
                                        onChange={this.updateManualPaymentInfo}
                                        required={true}
                                        showRequiredError={submitAttempted} />
                                    <ValidatedInput
                                        input={<CurrencyFormatInput disabled={blankCheck && blankCheck.checkAmount} placeholder={`${paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.ManualWire ? "Wire" : "Check"} Amount`} isIsraeli={false} tabIndex={720} />}
                                        onChange={this.updateManualPaymentInfo}
                                        name="manualPaymentAmount"
                                        value={paymentInfo.manualPayment.manualPaymentAmount || ''}
                                        required={true}
                                        showRequiredError={submitAttempted} />
                                        </div>}
                            </div>}
                    </div>
                        <div>
                            <div className="check-memo">
                                <label className="input-label">Check Memo (Optional)</label>
                                <textarea name="checkMemo" value={paymentInfo.checkMemo} tabIndex={730}
                                    onChange={e => this.props.updatePaymentInfo(e.target.name, e.target.value)} />
                            </div>
                        </div>
                    <div className="">
                        <label className="input-label">Report Memo (Optional)</label>
                        <textarea name="reportMemo" value={paymentInfo.reportMemo} tabIndex={740}
                            onChange={e => this.props.updatePaymentInfo(e.target.name, e.target.value)} />
                    </div>
                </div>

                <ThirdPartyPayeeModal
                    show={showModals.thirdPartyPayeeModal}
                    close={() => this.toggleModal("thirdPartyPayeeModal")}
                    payee={thirdParty}
                    recipientIsIsraeli={initialThirdParty.isIsraeli}
                    isManualPayment={isManualPayment}
                    useRecipientAddress={paymentInfo.thirdParty.useRecipientAddress}
                    recipientTypes={recipientTypes}
                    submitPayee={this.updateThirdParty}
                    submitAttempted={submitAttempted}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/PaymentInfo.jsx